import Axios from '../config/Axios';

export default function loadBreadcrumb(nFolderId) {
  return Axios.get('/folder/breadcrumb', { params: { "nId": nFolderId } }).then((oResponse) => oResponse.data.aBreadcrumb);
}
